import { type DynamicClient } from '@dynamic-labs-sdk/client';
import { getNetworkProviderBuilderRegistry } from '@dynamic-labs-sdk/client/core';

import { createEvmNetworkProvider } from '../utils/createEvmNetworkProvider';

export const registerEvmNetworkProviderBuilder = (
  client: DynamicClient
): void => {
  const networkProviderBuilderRegistry =
    getNetworkProviderBuilderRegistry(client);

  /**
   * If the Ethereum network provider builder is already registered, return.
   */
  if (networkProviderBuilderRegistry.get().get('EVM')) {
    return;
  }

  networkProviderBuilderRegistry.register({
    builder: (networkData) => createEvmNetworkProvider(networkData, client),
    chain: 'EVM',
  });
};
